import { normalize } from 'normalizr';

import { createNewAdConfiguration } from '../legacy/adMapper';
import adDataSchema from '../schemas/adDataSchema';

export const extractActiveFont = (adData) => {
  const { format_settings: formatSettings } = adData;
  const parsedFormatSettings = JSON.parse(formatSettings);
  const { activeFonts = [] } = parsedFormatSettings;
  return activeFonts;
};

export const extractMetadata = (adData) => {
  const {
    id,
    name,
    status,
    placement_id: placementId = '0',
    animation_settings: animationSettings,
    format_settings: formatSettings,
    campaign_id: campaignId,
    campaign_name: campaignName,
    format_id: formatId,
    format_name: formatName,
    available_formats: availableFormats,
    current_asset_folder: currentAssetFolder,
    published_ver: publishedVersion,
    standard_user_role: standardUserRole,
  } = adData;

  const parsedFormatSettings = JSON.parse(formatSettings);
  const {
    maintainAspectRatio = true,
    revealFormat = false,
    requiresFluidPlus = false,
    templateVersion = '',
  } = parsedFormatSettings;

  const css = parsedFormatSettings.css['css-src'];
  return {
    id,
    name,
    status,
    campaignId,
    campaignName,
    formatId,
    formatName,
    availableFormats,
    placementId,
    css,
    animationSettings,
    currentAssetFolder,
    maintainAspectRatio,
    publishedVersion,
    revealFormat,
    requiresFluidPlus,
    standardUserRole,
    templateVersion,
    loaded: true,
  };
};

export const parseConfiguration = (adData) => {
  const { orientations: viewport, configuration } = adData;

  return createNewAdConfiguration(
    JSON.parse(configuration),
    JSON.parse(viewport),
  );
};

export const normalizeAd = parsedAdData => normalize(parsedAdData, adDataSchema());



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/legacy/translator.js